import { unitOfMeasureSelectStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsUnitOfMeasureSelect";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

unitOfMeasureSelectStyles.unitOfMeasureSelect = {
    cssOverrides: {
        formField: css`
        margin-top: 10px;
        margin-left: 5px;

        label {
            font-size: ${TYPOGRAPHY.size.smaller};

            & + div {
                margin-top: 2px !important;
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                margin-left: 0px !important;
            `,
            css`
                margin-left: 0px !important;
            `,
            css`
                margin-left: 0px !important;
            `,
            null,
            null,
        ])}
        `,
    },
}